
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './containers/App'
import * as serviceWorker from './serviceWorker'


const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <BrowserRouter>
			<App />
		</BrowserRouter>
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
